import React, { FC } from 'react';
import { Button, Stack, Box, Typography, styled } from '@mui/material';

import {
  PVRed,
  PVBlack,
  PVGray,
  PVWhite,
  PVLightGray,
} from '@pv/common/colors';

import { Icon } from '../Icon';

const FilterIconWrapper = styled(Box)`
  width: 40px;
  height: 40px;
  background: ${PVRed};
  border-radius: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

interface MobileFilterBarButtonProps {
  startIcon: React.ReactNode;
  filterText: string[];
  onClick: () => void;
}

export const MobileFilterBarButton: FC<MobileFilterBarButtonProps> = ({
  startIcon,
  filterText,
  onClick,
}: MobileFilterBarButtonProps) => {
  return (
    <Button
      sx={{
        height: '70px',
        '&.MuiButton-root:hover': {
          backgroundColor: 'transparent',
        },
      }}
      fullWidth
      disableRipple
      onClick={onClick}
    >
      <Stack
        direction="row"
        width="100%"
        sx={{
          alignItems: 'center',
          justifyContent: 'space-between',
          textAlign: 'left',

          padding: '10px',
          paddingLeft: '20px',

          borderRadius: '50px',
          border: `1px solid ${PVLightGray}`,
          background: PVWhite,
          gap: '12px',

          boxShadow: '0px 2px 14px 0px rgba(0, 0, 0, 0.10)',
        }}
      >
        <Stack
          direction="row"
          gap="12px"
          alignItems="center"
          sx={{
            minWidth: 0,
            flex: 1,
          }}
        >
          <Box
            sx={{
              flexShrink: 0,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              color: PVBlack,
            }}
          >
            {startIcon}
          </Box>
          <Stack direction="column" sx={{ minWidth: 0 }}>
            <Typography
              variant="body1"
              sx={{
                fontWeight: 500,
                fontSize: '14px',
                lineHeight: '143%',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100%',
              }}
            >
              {filterText[0]}
            </Typography>
            <Typography
              variant="body2"
              color={PVGray}
              sx={{
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                width: '100%',
              }}
            >
              {filterText[1]}
            </Typography>
          </Stack>
        </Stack>

        <FilterIconWrapper>
          <Icon name="filters" size={20} />
        </FilterIconWrapper>
      </Stack>
    </Button>
  );
};
